import { get } from "lodash";

import { updateIgnition } from "./axle";

/**
 * Records an ignition session event
 */
export const createEvent = async ({
  ignitionToken,
  status,
  result,
  resultDetail,
  session,
  client,
  carrier,
  integration,
}: {
  ignitionToken: string;
  status: string;
  result: string;
  resultDetail: string;
  session: Record<string, any>;
  client: Record<string, any>;
  carrier?: string;
  integration?: string;
}) => {
  const type = `ignition.${status}`;
  console.log(`Creating an event with type: ${type}`);

  return await updateIgnition(ignitionToken, {
    status,
    lastEvent: {
      type,
      data: {
        token: ignitionToken,
        result,
        resultDetail,
        ...(carrier && { carrier }),
        ...(integration && { integration }),
        user: get(session, "user"),
        client: get(client, "id"),
      },
      createdAt: new Date().toISOString(),
    },
  });
};
